import React, { useState } from "react";

function Registration() {
  const [registerOption, setRegisterOption] = useState("Email");

  return (
    <div className="min-h-screen bg-gray-50 flex justify-center items-center px-4 sm:px-6 mt-20 sm:mt-10">
      {/* Main Container */}
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6 sm:p-8">
        {/* Title Section */}
        <div className="text-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
            Create Your Account
          </h2>
          <p className="text-sm sm:text-base text-gray-600">
            Join us and explore all the features
          </p>
        </div>

        {/* Form Section */}
        <form className="space-y-6">
          {/* Radio Buttons */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">
              Register with:
            </h3>
            <div className="flex flex-wrap gap-4 justify-center">
              {["Email", "Mobile", "UserName"].map((option) => (
                <label
                  key={option}
                  className="flex items-center space-x-2 text-sm sm:text-base"
                >
                  <input
                    type="radio"
                    name="register_content"
                    value={option}
                    checked={registerOption === option}
                    onChange={(e) => setRegisterOption(e.target.value)}
                    className="form-radio"
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Conditional Input Fields */}
          {registerOption === "Email" && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Email Address*
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {registerOption === "Mobile" && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Mobile Number*
              </label>
              <input
                type="text"
                placeholder="Enter your mobile number"
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {registerOption === "UserName" && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Username*
              </label>
              <input
                type="text"
                placeholder="Enter your username"
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {/* Name Inputs */}
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                First Name*
              </label>
              <input
                type="text"
                placeholder="Enter your first name"
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Last Name*
              </label>
              <input
                type="text"
                placeholder="Enter your last name"
                className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Password Inputs */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password*
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Confirm Password*
            </label>
            <input
              type="password"
              placeholder="Re-enter your password"
              className="mt-2 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Register
            </button>
          </div>

          {/* Footer Section */}
          <div className="text-center">
            <p className="text-sm sm:text-base text-gray-600">
              Already have an account?{" "}
              <a href="/login" className="text-blue-500 hover:underline">
                Login here!
              </a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Registration;
